import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IRenderContextMenuItemArgs } from '../type';

export const showAllItem = (_: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    if (!framework.service.edgelessCanvas.isEdgelessMode) return null;

    const type = 'show-all';
    const item = {
        disabled: !framework.service.edgelessCanvas.length,
        name: $t((tr) => tr.Tooltip_ShowAll),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            framework.service.edgelessCanvas.showAllObjects();
        },
    };

    return item;
};
